import { RouteRecordRaw } from "vue-router";
import { eGuaranteeTypes } from "@ntprsrf-frontend/internet/src/constants/APIEnums";

const taskNotificationRoute: RouteRecordRaw[] = [
  {
    path: "notifications",
    name: "NOTIFICATIONS",
    meta: {
      label: "Notifications",
      rebrand: true,
    },
    redirect: () => {
      return {
        name: "NOTIFICATIONS_DETAIL",
        params: {
          notificationTabType: "GENERAL",
          notificationRouteName: "notification",
        },
      };
    },
    children: [
      {
        name: "NOTIFICATIONS_DETAIL",
        path: ":notificationRouteName",
        meta: {
          hideBreadcrumb: true,
          eGuaranteeTypesCanAccess: [
            eGuaranteeTypes.NORMAL.VALUE,
            eGuaranteeTypes.FINANCIAL_INSTITUTION.VALUE,
            eGuaranteeTypes.GOVERNMENT_AGENCY.VALUE,
          ],
        },
        component: () => import("@/views/Notifications.vue"),
      },
    ],
  },
];

export default taskNotificationRoute;
